import "./index.scss"
import cn from "classnames"

const Block = ({ children, className }) => {
  return <div className={cn("people-block", className)}>{children}</div>
}

export default Block
